import { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { 
  getQuestionById, 
  addViewCount, 
  getNoticeDetail, 
  getFAQDetail, 
  addFaqViewCount, 
  addNoticeViewCount,
  getQuestionComments,
  getFAQComments,
  getReportType,
  reportQuestion
} from "@/api/questions";
import { currentUserIsFollow, followUser, cancelFollow } from '@/api/user'
import { Breadcrumb, Button, Modal, Input, Radio } from "antd";
import { useGetLoginInfo } from "@/hooks/useGetLoginInfo";
import "./index.less";
import UpvoteEyes from "@/components/UpvoteEyes";
import CommentInput from "@/components/CommentInput";
import CommentItem from "../CommentItem";
import CommentChildren from "../CommentChildren";
import { goLogin } from "@/utils/common";
import { CloudDownloadOutlined } from "@ant-design/icons";




const defaultQuestionUserAvatar='https://kaihong-developer.obs.cn-south-1.myhuaweicloud.com/developer/default/public/resources/v2/images/account/default_avatar.svg';

const questionsDetail = () => {
  const [modal, contextHolder] = Modal.useModal();
  const navigate = useNavigate();
  const [content, setContent] = useState<any>({});
  const [commentList, setCommentList] = useState<any[]>([]);
  const [commentPageNum, setCommentPageNum] = useState(1);
  const [commentTotal, setCommentTotal] = useState(0);
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [reportReason, setReportReason] = useState('');
  const [reportTypeList, setReportTypeList] = useState<any[]>([]);
  const [reportType, setReportType] = useState<string>('');
  const [reportCommentId, setReportCommentId] = useState<string>('');
  const location = useLocation();
  const pathNameMap = {
    'noticeDetail': {
      text: '通知公告',
      url: '/technicalSupport/notice',
      api: getNoticeDetail,
      addViewCountApi: addNoticeViewCount,
      commentApi: null
    },
    'feedbackDetail': {
      text: '问题反馈',
      url: '/technicalSupport/feedback',
      api: getQuestionById,
      addViewCountApi: addViewCount,
      commentApi: getQuestionComments
    },
    'faqDetail': {
      text: '常见Q&A',
      url: '/technicalSupport/faq',
      api: getFAQDetail,
      addViewCountApi: addFaqViewCount,
      commentApi: getFAQComments
    },
  }
  const type = location.pathname.split("/")[2];
  const questType = type.split("Detail")[0] as "faq" | "notice" | "feedback"
  const crumbItem = useMemo(() => {
    return pathNameMap[type as keyof typeof pathNameMap] || {};
  }, [location.pathname])
  
  const id = location.pathname.slice(location.pathname.lastIndexOf("/") + 1);
  
  const categoryText = content?.typeName|| "";
  const { authorization, portalAuthorization } = useGetLoginInfo();
  const isLogin = portalAuthorization && authorization;
  const [isFollow, setIsFollow] = useState(false)

  const getData = useCallback(() => {
    crumbItem.api(id).then((res: any) => {
      if (res.code === 200) {
        setContent(res.result);
        if (isLogin) {
          checkIsFollow(res.result.userId);
        }
      }
    }).catch((err: any) => {
      console.log("err", err);
    });
  }, []);
  const checkIsFollow = async(id: string) => {
    try {
      const res = await currentUserIsFollow(id)
      if (res.code === 200) {
        setIsFollow(res.result)
      }
    } catch (error) {
      console.log(error)
    }
  }
  const filterCommentList = (list: any[], id: string) => {
    return list.filter((item) => {
      if (item.children.length) {
        item.children = filterCommentList(item.children, id);
      }
      return item.id !== id;
    })
  }
  const afterDelete = (id: string, flag?: boolean) => {
    setCommentList((preList) => {
      return filterCommentList(preList, id)
    });
  }
  const afterSend = (questionId:string, parentId: string) => {
    getComments(true);
  }
  const handleFollow = async() => {
    const res = await followUser(content.userId)
    if (res.code === 200) {
      setIsFollow(true)
    }
  }
  const handleCancelFollow = () => {
    modal.confirm({
      title: '取消关注提示',
      content: '确认取消关注该用户吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async() => {
        const res = await cancelFollow(content.userId)
        if (res.code === 200) {
          setIsFollow(false)
        }
      },
    });
    
  }
  const onFollow = () => {
    if (!isLogin) {
      goLogin();
      return;
    }
    if (isFollow) {
      handleCancelFollow()
    } else {
      handleFollow()
    }
  }
  const getComments = useCallback((reset?: boolean) => {
    if(crumbItem?.commentApi){
      crumbItem.commentApi(id, {pageSize: 5, pageNumber: commentPageNum}).then((res: any) => {
        if(res.code === 200){
          if (!reset) {
            setCommentList((preList) => {
              return preList.concat(res.result.records)
            });
          } else {
            setCommentList(res.result.records)
            setCommentPageNum(1);
          }
          setCommentTotal(res.result.total);
        }
      })
    } else {
      setCommentList([]);
    }
  }, [crumbItem.commentApi, commentPageNum]);

  useEffect(() => {
    if(crumbItem.addViewCountApi){
      crumbItem.addViewCountApi(id).then((res: any) => {
          console.log("addViewCount", res);
        }).finally(() => {
          getData();
        })
    }
  }, [crumbItem.addViewCountApi]);
  useEffect(() => {
    getComments();
  }, [commentPageNum]);
  // 评论输入框显示隐藏逻辑
  const [showBottomBar, setShowBottomBar] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const commentInputTopRef = useRef(null);

  useEffect(() => {
    const stickyDom = commentInputTopRef.current;
    if (!stickyDom) return;

    // 创建交叉观察器
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const rect = entry.boundingClientRect;
        // 判断：元素完全滚出视口顶部（向上消失）才展示底部栏 
        if (rect.bottom < 0 && !showBottomBar) {
          setShowBottomBar(true);
        } 
        if (rect.bottom > 0) {
          setShowBottomBar(false);
        }
      },
      { threshold: 0 }
    );
    observerRef.current = observer;
    // 监听sticky盒子
    observer.observe(stickyDom);

    // 组件销毁时执行清理函数，移除监听
    return () => {
      if (observerRef.current) {
        observerRef.current.unobserve(stickyDom); // 停止监听目标元素
        observerRef.current.disconnect(); // 销毁整个观察实例
        observerRef.current = null;
      }
    };
  }, [])
  useEffect(() => {
    getReportType().then((res: any) => {
      if (res.code === 200) {
        const reportTypeList = res.result.map((item: any) => {
          return {
            value: item.id,
            label: item.typeName,
            ...item
          }
        })
        setReportTypeList(reportTypeList);
      }
    })
  }, [])
  const handleReport = (id: string) => {
    if (!isLogin) {
      goLogin();
      return;
    }
    setReportCommentId(id);
    setReportModalOpen(true);
  }
  const handleCancelReport = () => {
    setReportModalOpen(false);
    setReportCommentId('');
    setReportType('');
    setReportReason('');
  }
  const onReport = () => {
    if (!reportType) {
      window.message?.warning('请选择违规类型');
      return
    }
    const requireDesc = reportTypeList.find((item: any) => item.id === reportType)?.requireDesc;
    if (requireDesc && !reportReason) {
      window.message?.warning('请填写违规细节描述');
      return;
    }
    reportQuestion(questType === 'feedback' ? 'questAndAnswer' : 'faq', {
      reportDesc: reportReason,
      commentId: reportCommentId,
      reportTypeId: reportType,
    }).then((res: any) => {
      if (res.code === 200) {
        window.message?.success(res.message, 2);
        handleCancelReport();
      } else {
        window.message?.error(res.message, 2);
      }
    })
  }
  return (
    <div className="questions-detail-wrap">
      {contextHolder}
      <div className="questions-detail-content">
        <div className="questions-detail-brod">
          <Breadcrumb
            separator=">"
            items={[
              {
                title: (
                  <a href={crumbItem.url} style={{ color: "#666666" }}>
                    {crumbItem.text}
                  </a>
                ),
              },
              {
                title: <span style={{ color: "#1047F5" }}>详情</span>,
              },
            ]}
          />
        </div>
        {content?.id && (
          <>
            <div className="questions-detail-title">{content?.overview || content?.title}</div>
            <div className="questions-detail-time-wrap">
              <div className="question-detail-user">
                <img src={content?.avatar || defaultQuestionUserAvatar} alt="" onClick={() => navigate(`/user-detail/${content.userId}`)}/>
                <span onClick={() => navigate(`/user-detail/${content.userId}`)}>{content?.nickName || content?.userName}</span>
                <span>{content?.createTime}</span>
                <span className="follow" onClick={onFollow}>{isFollow ? '已关注' : '关注'}</span>
              </div>
            </div>
            {categoryText && <div className="questions-detail-category">{categoryText}</div>}

            <div className="questions-detail-context">
              <div dangerouslySetInnerHTML={{ __html: content?.description || content?.content || "" }} />
            </div>
            {content?.filePath && (
              <Button
                style={{ marginBottom: "12px" }}
                type="primary"
                icon={<CloudDownloadOutlined />}
                onClick={() => {
                  if (portalAuthorization && authorization) {
                    window.open(content?.filePath);
                  } else {
                    goLogin();
                  }
                }}
              >
                附件下载
              </Button>
            )}
            <UpvoteEyes
              data={content}
              type={questType}
              upvoteType={questType === 'notice' ? 'notice' : 'question'}
              showMore
              showCollect
            />
          </>
        )}
      </div>
      { 
        questType !== 'notice' && 
        <CommentInput
          ref={commentInputTopRef} 
          className='show-top' 
          type={questType} 
          questionId={id}
          afterSend={afterSend}
        />
      }
      {
        commentList?.length > 0 &&<div className="questions-detail-answer">
        <div className="questions-detail-answer-header">问题答复</div>
          {commentList?.map((item: any) => {
            const commentProps = {
              type: questType,
              questionId: id,
              afterDelete: afterDelete,
              afterSend: afterSend,
              handleReport: handleReport,
            }
            return (
              item.children.length ? 
              <>
                <CommentItem 
                  key={`${item.id}-item`} 
                  item={item} 
                  {...commentProps}
                />
                <CommentChildren 
                  key={item.id} 
                  childrenItems={item.children} 
                  {...commentProps}
                />
              </> :
              <CommentItem 
                key={item.id} 
                item={item} 
                {...commentProps}
              />
            );
          })}
        </div>
      }
      {
        commentTotal > commentList?.length && (
          <div className="more-btn" onClick={() => {
            setCommentPageNum((pre) => {
              return pre + 1
            })
          }}>
            <span>查看更多</span>
            <img src={require("@/assets/images/icon-expand.png")} alt="" />
          </div>
        )
      }
      {questType !== 'notice' && <CommentInput
        className={showBottomBar ? 'fixed-bottom' : ''}
        type={questType}
        questionId={id}
        afterSend={afterSend}
      />}
      <Modal
        width={580}
        title="举报"
        open={reportModalOpen}
        onOk={onReport}
        onCancel={handleCancelReport}
        className="report-modal"
        okButtonProps={{
          disabled: !reportType
        }}
      >
        <div className="report-modal-content">
        <span className="report-form-title">违规类型</span>
          <div className="report-modal-content-type">
            <Radio.Group
              name="reportType"
              value={reportType}
              onChange={(e) => setReportType(e.target.value)}
              options={reportTypeList}
            />
          </div>
          <div className="report-modal-content-reason">
            <span className="report-form-title">补充描述</span>
            <Input.TextArea
              value={reportReason}
              showCount
              maxLength={200}
              onChange={(e) => setReportReason(e.target.value)}
              placeholder="补充描述违规细节，方便审核人员判定"
              style={{ height: 90, resize: 'none' }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default questionsDetail;
